import { Link } from "react-router-dom";
import pbIllustration from "../img/pb-illustration.png";
import { pbJoinLink, superbStudyLink } from "../data/Data";

const testimonials = [
  {
    quote:
      "The one-to-one format is very helpful to maximize the relationship. It's especially great for the newly diagnosed with aphasia, I'm also getting a lot out of it.",
    who: "Ally",
    className: "quote--purple",
  },
  {
    quote:
      "It is wonderful... It is tough to speak and read and write. [My Ally] is amazing. Patience and persistence AND a friend too. It is tough, but [my Ally] constantly reassuring me.",
    who: "Buddy",
    className: "quote--teal",
  },
];

const JoinButton = () =>
  /^https?:/.test(pbJoinLink) ? (
    <a href={pbJoinLink} className="btn-join" target="_blank" rel="noopener noreferrer">
      Join Today!
    </a>
  ) : (
    <Link to={pbJoinLink} className="btn-join">Join Today!</Link>
  );

export default function PeerBefriending() {
  return (
    <div className="page">
      <h1 className="page-title">Peer Befriending</h1>

      <div className="page-split">
        <div className="page-split__text">
          <p>
            To help address the social isolation that can come along with an aphasia diagnosis,
            NAS launched a <strong>free, online peer befriending program</strong> run by volunteers
            and based on the{" "}
            <a href={superbStudyLink} target="_blank" rel="noopener noreferrer" className="text-link">
              UK-based SUPERB study
            </a>
            . To develop the program, our speech-language pathologists completed a 6-week training
            with the SUPERB Trial creators to guide adapting the approach for an online and US
            context.
          </p>
          <p>
            In this US program, <strong>Allies (PWA who have found ways to thrive)</strong> are
            paired with <strong>Buddies (PWA seeking support and connection)</strong>. The Allies
            are trained to use their knowledge as peer navigators to provide{" "}
            <strong>direct peer support for the self-management and mental health</strong>, while
            offering <strong>meaningful connections and socialization</strong>. Training includes
            suicide prevention information and mental health screening.
          </p>
        </div>

        <div className="page-split__media">
          <img
            src={pbIllustration}
            alt="A person with aphasia waving to a peer on a video call"
            className="pb-illustration"
          />
          <JoinButton />
        </div>
      </div>

      <div className="pb-feedback">
        <div className="pb-benefits">
          <h2>Benefits for people with aphasia include...</h2>
          <ul>
            <li>Positive effects on mood</li>
            <li>Helps combat loneliness and boredom</li>
            <li>Social connection</li>
          </ul>
        </div>

        <div className="pb-quotes">
          <h2 className="pb-quotes__title">What participants are saying...</h2>
          <div className="pb-quotes__grid">
            {testimonials.map(({ quote, who, className }) => (
              <figure key={who} className={`quote ${className}`}>
                <blockquote>“{quote}”</blockquote>
                <figcaption>({who})</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
